import type { SpinTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const spinDark: SpinTheme = {
  name: 'Spin',
  common: commonDark,
  self
}

export default spinDark
